import { PartialRecord } from '@/types';
import { SxProps, Theme } from '@mui/material';

export const sx = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '0px !important',
  },
  dialogContentText: {
    paddingTop: '12px',
    paddingBottom: '12px',
  },
  dialogActions: {
    border: 'none',
    display: 'flex',
    justifyContent: 'flex-end',
  },
} satisfies PartialRecord<string, SxProps<Theme>>;
